<template>
    <div>
        <div class="text-16 font-regular text-a-blue-2140a6 pb-1.5">
            {{inputLbl.name}}
        </div>
        <div class="relative" :class="[isError ? 'pb-12' : 'pb-5']">
            <input type="tel"
                class="w-full bg-a-blue-f2f5ff rounded-sm h-12 px-3 py-1 placeholder-a-gray-a4a4a4 text-a-blue-001b73"
                :class="[isError ? '' : '']"
                v-model="content"
                :placeholder="inputLbl.placeholder"
                :maxlength="inputMaxLength"
                :data-cy="$attrs['data-cy'] || inputLbl.name"
                @input="onChange()"
                @click="onClick()">
            <div class="text-a-red-ff4d4d text-16 font-regular absolute bottom-5 left-0 w-full" v-if="isError">
                {{getErrorMsg}}
            </div>
        </div>
    </div>
</template>
<script>
import Util from "@/helper/Utility.js";
import RegxHelper from "@/helper/RegxHelper.js";

/**
 * @property {String} v-model:inputValue (required) bind value
 * @property {Number} minLength (optional) Minimum length.
 * @property {Number} maxLength (optional) Maximum Length.
 * @property {String} delimeter (optional) Character seperate number.
 * @property {Object} errorInfo (required) Validate result. example : { isValid: true, msg: '',}
 * @property {Boolean} isShowError (optional) Show/Hide Error label.
 * @property {Boolean} isSubmitted (optional) Show/Hide Error after save.
 * @property {Object} inputLbl (required) Text for component.
 */
export default {
    name: "InputContactNumber",
    props: {
        // v-model
        inputValue:     { type: String },
        // props
        minLength:      { type: Number },
        maxLength:      { type: Number, default: 0 },
        delimeter:      { type: String, default: '' },
        errorInfo:      { type: Object, required: true },
        isShowError:    { type: Boolean, default: false },
        isSubmitted:    { type: Boolean, default: false },
        // text
        inputLbl:       { type: Object, required: true },
    },
    computed: {
        isError: function() {
            return (this.isShowError && this.isSubmitted && !this.errorInfo.isValid);
        },
        getErrorMsg: function() {
            return (this.isShowError && this.isSubmitted && !this.errorInfo.isValid)
                ? this.errorInfo.msg
                : '';
        }
    },
    data: function() {
        return {
            content: this.inputValue,
            inputMaxLength: null,
        };
    },
    created: function() {
        if (this.maxLength > 0) {
            this.inputMaxLength = this.maxLength;
        }
        this.onChange();
    },
    mounted: function() {
        this.validateInput();
    },
    methods: {
        validateInput: function () {
            if (!this.inputLbl) {
                return;
            }
            // set default.
            this.errorInfo.setValid(true);
            this.errorInfo.setMsg('');
            // required
            if (this.inputLbl.required && !this.content) {
                this.errorInfo.setValid(false);
                this.errorInfo.setMsg(this.inputLbl.required)
                return;
            }
            // too short
            if (this.inputLbl.too_short && this.minLength
                && (this.content.length < this.minLength)) {
                this.errorInfo.setValid(false);
                this.errorInfo.setMsg(Util.stringFormat(this.inputLbl.too_short, this.minLength));
                return;
            }
        },
        onChange: function() {
            let input = Util.isEmptyStr(this.content) ? '' : this.content;
            input = RegxHelper.removeEmoji(input);
            input = input.replace(/^[^0].*/, '');
            input = RegxHelper.removeNotNumber(input);

            let tel = input;

            if (!Util.isEmptyStr(this.delimeter)) {
                let n1, n2, n3;
                if (input.length <= 3) {
                    // do nothing
                } else if (input.length <= 6) {
                    n1 = input.substr(0, 3);
                    n2 = input.substr(3, 3);
                    input = n1 + this.delimeter + n2;
                } else {
                    n1 = input.substr(0, 3);
                    n2 = input.substr(3, 3);
                    n3 = input.substr(6);
                    input = n1 + this.delimeter + n2 + this.delimeter + n3;
                }
            }

            this.content = input;
            this.validateInput();
            this.$emit('onChange');
            this.$emit('update:inputValue', tel);
        },
        onClick: function(){
            this.$emit('onClick');
        }
    },
}
</script>
<style lang="scss" scoped>

</style>
